import { HttpErrorResponse, HttpStatusCode } from "@angular/common/http";

export const BadRequestGenericError =
    "Request not understood. There may be a network issue. Please attempt to submit your request again. " +
    "If this problem persists, please use the Report a Problem page found on the menu to alert your support team.";

export const ForbiddenGenericError =
    "You don't have authorisation for this feature. Please refresh your page. If this problem persists, " +
    "please use the Report a Problem page found on the menu to alert your support team.";

export const GenericError =
    "An error has occurred at the website and your support team will need to fix the problem. " +
    "A preliminary report has been sent to the support team.Please do follow - up on the preliminary " +
    "report using the Report a Problem page";

export const NotFoundGenericError = "Entity not found";

export function extractBadRequestError(errorResponse: HttpErrorResponse, defaultErrorMessage?: string): string | null {
    if (errorResponse.status !== HttpStatusCode.BadRequest) {
        return null;
    }

    let resultErrorMessage = errorResponse.message ?? defaultErrorMessage ?? BadRequestGenericError;

    if (typeof errorResponse.error === "object") {
        // OData errors
        if (errorResponse.error.error && errorResponse.error.error.message) {
            resultErrorMessage = errorResponse.error.error.message;
        }

        // Validation errors
        if (errorResponse.error?.errors) {
            resultErrorMessage = Object.keys(errorResponse.error.errors)
                .map(
                    key =>
                        `${key}: ${
                            Array.isArray(errorResponse.error.errors[key])
                                ? (<string[]>errorResponse.error.errors[key]).join(", ")
                                : errorResponse.error.errors[key]
                        }`
                )
                .join("\n");
        }
    } else {
        resultErrorMessage = errorResponse.error;
    }

    return resultErrorMessage;
}

export function extractGenericError(errorResponse: HttpErrorResponse, defaultErrorMessage?: string) {
    return errorResponse.error ? errorResponse.error : defaultErrorMessage ?? GenericError;
}

export function extractErrorMessage(errorResponse: unknown, defaultErrorMessage?: string) {
    let message: string;

    if (!(errorResponse instanceof HttpErrorResponse)) {
        return defaultErrorMessage;
    }

    switch (errorResponse.status) {
        case HttpStatusCode.BadRequest:
            message = extractBadRequestError(errorResponse, defaultErrorMessage);
            break;
        case HttpStatusCode.Forbidden:
            message = ForbiddenGenericError;
            break;
        case HttpStatusCode.NotFound:
            message = NotFoundGenericError;
        case HttpStatusCode.Unauthorized:
            break;
        default:
            message = extractGenericError(errorResponse, defaultErrorMessage);
    }

    return message;
}

export function extractError(errorResponse: HttpErrorResponse, errorMessage?: string) {
    let message: string;
    switch (errorResponse.status) {
        case HttpStatusCode.BadRequest:
            message = extractBadRequestError(errorResponse, errorMessage);
            break;
        case HttpStatusCode.Forbidden:
            message = ForbiddenGenericError;
            break;
        case HttpStatusCode.Unauthorized:
            break;
        default:
            message = extractGenericError(errorResponse, errorMessage);
    }

    return message;
}
